/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsactivitytitle2Inputs */

const en_statsactivitytitle2 = /** @type {(inputs: Statsactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How active accounts are`)
};

const de_statsactivitytitle2 = /** @type {(inputs: Statsactivitytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie aktiv die Konten sind`)
};

/**
* | output |
* | --- |
* | "How active accounts are" |
*
* @param {Statsactivitytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsactivitytitle2 = /** @type {((inputs?: Statsactivitytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsactivitytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsactivitytitle2(inputs)
	return de_statsactivitytitle2(inputs)
});
export { statsactivitytitle2 as "statsActivityTitle" }